// src/components/NodeManagement/components/LoadingSpinner.jsx
import React from 'react';

const LoadingSpinner = ({ size = 'default', text }) => (
  <>
    <span className={`spinner ${size === 'small' ? 'small' : ''}`}></span>
    {text && <span>{text}</span>}
  </>
);

export default LoadingSpinner;
